import { render, staticRenderFns } from "./ReinviteMail.vue?vue&type=template&id=c6775e06&scoped=true"
import script from "./ReinviteMail.vue?vue&type=script&lang=js"
export * from "./ReinviteMail.vue?vue&type=script&lang=js"
import style0 from "./ReinviteMail.vue?vue&type=style&index=0&id=c6775e06&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6775e06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6775e06')) {
      api.createRecord('c6775e06', component.options)
    } else {
      api.reload('c6775e06', component.options)
    }
    module.hot.accept("./ReinviteMail.vue?vue&type=template&id=c6775e06&scoped=true", function () {
      api.rerender('c6775e06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/back/Modal/ReinviteMail.vue"
export default component.exports